module.exports = __webpack_public_path__ + "static/media/icn_search_failed_big.ac40c3bc.svg";